<template>
  <div class="home">
    <div class="full-screen loading-message" v-if="!pageloaded && screen != 'error'">
      <span class="lds-dual-ring dark full-screen"></span>
      <p>We're just getting your code ready</p>
    </div>
    <error v-if="screen == 'error'" />
    <div v-else>
      <div class="lds-dual-ring full-screen" v-if="!loaded && pageloaded"></div>
      <div v-else>
        <transition name="fade">

          <div v-show="pageloaded">
            <div class="header">
                <img alt="Logo" v-on:load="imageLoaded++" :src="config.logo_image_url" :width="config.logo_width">
                <div class="voucher-image" :class="screen == 'redeemed' ? 'white-overlay' : ''">
                   <img v-on:load="imageLoaded++" :src="config.campaign_image_url" alt="voucher" title="voucher" />
                </div>
            </div>
            <div class="wrapper" :class="{loading:loading}">

              <welcome v-if="screen == 'welcome'" />
              <activate v-if="screen == 'activation'" />
              <voucher v-if="screen == 'voucher'" />
              <redeemed v-if="screen == 'redeemed'" />
              <toggle-voucher v-if="screen == 'toggle-voucher'" />

              <!-- MODAL ERROR-->
              <div class="modal error" v-if="errorActive">
                <p>{{errorMessage}}</p>
                <button v-on:click="errorActive = false" v-bind:style="{ color: config.button_colour, backgroundColor: config.button_bg_colour }">OK</button>
              </div>

              
            </div>
            <div class="footer_text" v-if="config.footer_text" v-html="config.footer_text" :style="getStyle('p')"></div>

          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {
    // ActivateVoucher
  },
  data : function(){       
    return {
      errorActive   :false,
      uniquecode    :'',
      errorMessage  :'',
      activationDate: {
        time: '',
        date: ''
      },
      imageLoaded:0
      
    }
  },
  mounted() {

  },
  created : function(){


  },
  computed: {

      // returns true when both images on the page has loaded, allows for smooth first laod
      pageloaded(){
        
        if(this.imageLoaded == 2)
          return true;
        return false;

      },
      config(){
          return this.$store.getters.getCamapignConfig;
      },

      loaded(){
          return this.$store.getters.getAppLoaded;
      },

      loading(){
          return this.$store.getters.getAppLoading;
      },

      apiCampaignParams(){
          return this.$store.getters.getCampaignApiVars;
      },

      screen(){
          return this.$store.getters.getScreen;
      },
      count(){
          return this.$store.getters.getCount;
      }
  },
  methods:{

     
   
  }
}
</script>
<style lang="scss">

    .footer_text {
      margin-top: 25px;
      p {
        font-size: 14px;
      }
    }
    .mt4 {
      margin-top: 4em;
    }

</style>